var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F0BB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7201 17.6469L16.4267 36.5004C16.1939 36.9036 16.0707 37.3608 16.0693 37.8264C16.068 38.292 16.1887 38.7499 16.4193 39.1544C16.6498 39.5589 16.9823 39.896 17.3836 40.1322C17.785 40.3683 18.2411 40.4953 18.7067 40.5004H41.2935C41.7591 40.4953 42.2152 40.3683 42.6165 40.1322C43.0178 39.896 43.3503 39.5589 43.5809 39.1544C43.8115 38.7499 43.9321 38.292 43.9308 37.8264C43.9295 37.3608 43.8063 36.9036 43.5735 36.5004L32.2801 17.6469C32.0424 17.2551 31.7077 16.9311 31.3084 16.7063C30.909 16.4814 30.4584 16.3633 30.0001 16.3633C29.5418 16.3633 29.0912 16.4814 28.6918 16.7063C28.2925 16.9311 27.9578 17.2551 27.7201 17.6469V17.6469Z",
    stroke: "white",
    strokeWidth: 3.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.5V29.8334",
    stroke: "white",
    strokeWidth: 3.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35.167H30.0133",
    stroke: "white",
    strokeWidth: 3.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/status-icon.0c454df155795c965136e14f648854fa.svg";
export { ForwardRef as ReactComponent };